export default __webpack_public_path__ + "static/media/gnl8.39da196d.jpg";